import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


@Component({
  selector: 'app-view-login-report',
  templateUrl: './view-login-report.component.html',
  styleUrls: ['./view-login-report.component.scss']
})
export class ViewLoginReportComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  endDate: any;
  startDate: any;
  UserId: any;

  constructor( private datepipe: DatePipe,
    private gs: GeneralService, private http: HttpClient,
    public dialogRef: MatDialogRef<ViewLoginReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log('dvk',this.data)
    this.startDate = this.data.StartDate
    this.endDate = this.data.EndDate
    this.UserId = this.data.UserID
 
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      // ordering: true,
      searching: false,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        console.log('length',dataTablesParameters)
        this.http
          .get<DataTablesResponse>(

            `${this.gs.viewLoginReport()}` + `${this.UserId}` + `?endDate=${this.endDate}` + `&startDate=${this.startDate}` +
            `${dataTablesParameters.length.value != '' ? '&Records=' + dataTablesParameters.length : ''}` +
             `&PageNO=${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}`

          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.total_count,
              recordsFiltered: resp.total_count ,
              data: resp.data,
            });
            
          });
      },
      columns: [
        {
          title: 'Sr.No.',
          data: null,
          render: (data, type, row, meta) => {
            return meta.row + 1;
          },
        },
        {
          title: 'Login Date',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.login_date, 'dd-MM-yyyy');
          },
        },
        {
          title: 'Login Time',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.login_date, 'HH:mm:ss');
          },
        },


      ],

    };
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  close(){
    this.dialogRef.close()
  }
}
